import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UserProfileComponent } from "./user-profile.component";
import { AuthGuard } from "../../auth-guard.service";

const profileRoutes:Routes = [
    {
        path: 'profile',
        component: UserProfileComponent,
        pathMatch: 'full',
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(profileRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class UserProfileRoutingModule {}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/user-profile/user-profile-routing.module.ts